// state.js

export default {
    fields: [],
    isFieldsUpdated: false,
    messages:[],
    currentPage: 0,
    lasPage: 0,
    isSearchDone: true,
    lastDevicesMessages:[],
    selectedFields: [],
};
